<template>
  <el-dialog 
    :title=dialogTitle 
    :visible.sync="dialogAddRulesVisible" 
    :before-close="cancel"
    width="35%"
    :close-on-click-modal="false"
    center
  >
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="150px" class="add-user-form">
      <el-form-item label="策略组唯一标识" prop="tag" required>
        <el-input type="text" v-model="ruleForm.tag" disabled></el-input>
      </el-form-item>
      <el-form-item label="广告SDK执行顺序" prop="sort">
        <el-select v-model="ruleForm.sort" multiple placeholder="请选择执行顺序" style="width:100%">
          <el-option
            v-for="item in ruleSortList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流量权重" prop="percent">
        <el-input type="text" v-model.number="ruleForm.percent" autocomplete="off" placeholder="请输入流量权重..."></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit('ruleForm')">保存</el-button>
      <el-button @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogAddRulesVisible: {
      type: Boolean,
      default: false
    },
    isEditRule: {
      type: Boolean,
      default: false
    },
    ruleSortList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      ruleForm: {
        tag: '',
        sort: [],
        percent: ''
      },
      supplierOptions: [],
      rules: {
        sort: [
          { required: true, message: '广告SDK执行顺序不能为空', trigger: 'change' }
        ],
        percent: [
          { required: true, message: '流量权重不能为空'},
          { type: 'number', min: 0, message: '流量权重必须是大于等于0的数字'}
        ]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.isEditRule ? '编辑策略' : '新建策略';
    }
  },
  methods: {
    open (row) {
      if (!row) {
        this.$nextTick(function () {
          this.$refs.ruleForm.resetFields();
          
          this.ruleForm.tag = this.$getUniqueId(1);
        })
      } else {
        this.ruleForm = Object.assign({}, row);
      }
    },

    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var ruleForm = {
            tag: this.ruleForm.tag,
            sort: this.ruleForm.sort,
            percent: this.ruleForm.percent
          }
          this.$emit('submit', ruleForm);
        }
      });
    },

    cancel () {
      this.$refs.ruleForm.resetFields();
      this.$emit('cancel');
    }
  }
}
</script>

<style lang="scss" scpoed>
.add-user-form {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AddRules.vue